export const Config = {
    ACHIVEMENT_COUNT: [5000, 10000],
    TOTAL_COUNT: {
        DIGIT: 6
    },
    MAIN_COUNT: {
        DIGIT: 4,
        INCREMENT: 1
    },
    AUTO_UPDATE_INTERVAL: 3000,
    REWARD_DIR: {
        '1': 'A7mNaeEh',
        '2': '6354908134112'
    }
}